import { styled } from 'styled-components';
import { Title } from 'components/Base/Typography';

export const MetricTitle = styled(Title)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
`;
